<div class="alert-popup-backdrop">
  <div class="alert-popup-card">
    <div class="alert-popup-header">
      <div class="alert-icon" aria-hidden="true">!</div>
      <div class="alert-header-text">
        <h3>{{ header }}</h3>
      </div>
      <button type="button" class="close" aria-label="Close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert-popup-body">
      <ng-container *ngFor="let line of messageLines; let i = index">
        <p [class.secondary]="i > 0">{{ line }}</p>
      </ng-container>
    </div>

    <div class="alert-popup-footer">
      <ng-container *ngIf="showConfirmation">
        <button type="button" class="btn btn-primary" (click)="confirm()">{{ confirmText }}</button>
        <button type="button" class="btn btn-outline-primary" (click)="cancel()">{{ cancelText }}</button>
      </ng-container>
      <button *ngIf="showViewCart" type="button" class="btn btn-primary" (click)="viewCart()">{{ viewCartText }}</button>
      <button *ngIf="showClearCart" type="button" class="btn btn-outline-primary" (click)="clearCart()">{{ clearCartText }}</button>
      <button *ngIf="!showConfirmation && !showViewCart && !showClearCart" type="button" class="btn btn-primary" (click)="dismissModal()">{{ buttonText }}</button>
    </div>
  </div>
</div>
